import React, { useState, useEffect } from "react";

// import internal components
import TableQR from "./components/TableQR";
import AddQRElement from "./components/AddQRElement";

// import external components
import { getter } from "../../functions/axios";
import { Box, Typography } from "@mui/material";

export default function QrOverviewPage() {
    let requestURL = "list/";

    const [qrData, setQrData] = useState([]);
    const [loading, setLoading] = useState(true);

    const sortByName = (a, b) => {
        return a.name.localeCompare(b.name);
    };

    useEffect(() => {
        getter(requestURL).then((response) => {
            if (response.status === 200) {
                setQrData(response.data.sort(sortByName));
                setLoading(false);
            }
        });
    }, [requestURL]);

    const addNewQR = (newQR) => {
        setQrData([...qrData, newQR].sort(sortByName));
    };

    const deleteQR = (indexToDelete) => {
        const data = qrData.filter((item, index) => index !== indexToDelete);
        setQrData(data.sort(sortByName));
    };

    const updateQR = (indexToUpdate, newQR) => {
        const data = qrData.map((item, index) =>
            index === indexToUpdate ? newQR : item
        );
        setQrData(data);
    };

    return (
        <Box>
            <Typography variant="h5" gutterBottom>
                Dynamic QR Codes
            </Typography>
            <Typography variant="body1" color="text.secondary" gutterBottom>
                These QR codes are trackable and the destination URL can be changed at any time without having to reprint the QR code.
            </Typography>
            <AddQRElement addNewQR={addNewQR} />
            {loading ? (
                <div style={{ textAlign: "center", marginTop: "20px" }}>
                    Loading...
                </div>
            ) : (
                <TableQR
                    addNewQR={addNewQR}
                    data={qrData}
                    deleteQR={deleteQR}
                    updateQR={updateQR}
                />
            )}
        </Box>
    );
}
